import React, {useEffect, useState, Fragment, useRef} from 'react'
import {Card, Col, Container, Form, Row, Modal, Button } from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import { LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import {formato_rut, formatearNumero, isValidParam} from '../../../../common/Formatos'
import {obtenerComboRegistrarHito} from '../../../../store/actions/cierre-gestion-action'
 import { useLocation, useNavigate } from 'react-router-dom'
 import Mensajes from '../../../mensajes'

const CierreGestion = ({formik, tieneRecupero, setTieneRecupero,setIsRegistraHito, showToast, setShowToast, setPagoTotal, setPagoCuotas}) => {
    const fileRef = useRef();
    const [loading, setLoading]=useState(false)  
    const data_cierre_modal = useSelector((state) => state.cierreGestionReducer)
    const {cfg_form19, datosCierreGestion, comboRegistrarHito,respuestaModalCierre} = data_cierre_modal
    const data_gestion = useSelector((state) => state.procesoExtrajudicialReducer)
    const {datosGestionImplicado} = data_gestion
    // Data de CIA
    const data_modal_cia = useSelector((state) => state.modalCartaCiaTerceroReducer)
    const {montosInformados} = data_modal_cia
    const [tipoGestion, setTipoGestion] = React.useState(false)
    const [ambitoGestion, setAmbitoGestion] = React.useState(false)
    const [isChecked, setIsChecked] = React.useState(true)
    const [registrarHito, setRegistrarHito] = React.useState('')
    const [comentario, setComentario] = React.useState('')
    const [fechaOcurrencia, setFechaOcurrencia] = React.useState('')
    const [fechaMin, setFechaMin]=useState('')

    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const dispatch = useDispatch()
    const history =useNavigate()
    const {state}=useLocation()
    
    const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoDirecto'))
    useEffect(()=>{
        if(respuestaModalCierre  && respuestaModalCierre.respuestaModalCierre["code"]===1) {
            setTimeout(()=> history('/area-trabajo-recupero-directo',{state:{queryState}}), 2000)
        }

    },[respuestaModalCierre])

    useEffect(()=>{
        setFechaMin(datosGestionImplicado && convertirFecha(datosGestionImplicado.datosGestionImplicado[0]['fechaSiniestroFormat']))
    },[datosGestionImplicado])

    useEffect(() => {
        setTipoGestion(datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'] !== '' && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'] !== null && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'] !== undefined ? parseInt(datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion']) : '')
        setAmbitoGestion(datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'] !== '' && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'] !== null && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'] !== undefined ? parseInt(datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion']) : '')
    }, [datosGestionImplicado])

    useEffect(() => {
        setLoading(true)
        let query = Buffer.from(JSON.stringify({tipoGestion: tipoGestion, ambitoGestion: ambitoGestion, idSituacion: 215002, idModoIngreso: null})).toString('base64')
        dispatch(obtenerComboRegistrarHito(query)).then(()=>setLoading(false))
    }, [])
    
    const convertirFecha = (fecha) => {
        if (fecha !== null && typeof fecha !== undefined) {
            const [dia, mes, ano] = fecha ?. split('-')
            const fechaFormat = [ano, mes, dia].join('-')
            return fechaFormat
        } else 
            return null
    }
    const hoy = () => {
        const fecha = new Date()
        const hoy = fecha.toISOString().split('T')[0]
        return hoy
    }
    const handleChange = (e) => {
        if(e.target.value == 215002){
            setTieneRecupero(1)            
        } else {
            setTieneRecupero(0);
            setPagoTotal('');
            setPagoCuotas('');
        }
        setLoading(true)
        let query = Buffer.from(JSON.stringify({tipoGestion: tipoGestion, ambitoGestion: ambitoGestion, idSituacion: e.target.value, idModoIngreso: null})).toString('base64')
        dispatch(obtenerComboRegistrarHito(query)).then(()=>setLoading(false))
        setIsChecked(!isChecked)
    }
    const handleCloseToast = () => {
        setShowToast(false);
    }
    return (
        <>
            <style type='text/css'>
                {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }    
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    `} </style>

        <LoadingComponent show={loading}/>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6'
                        style={
                            {
                                backgroundColor: '#4F517A',
                                color: 'white'
                            }
                            }>
                        {cfg_form19 ? cfg_form19.cfg_form19['cierregestion-title-cierre'] : ''}
                    </Card.Header>
                    <Container>
                        <Container> {
                            cfg_form19 ? (
                                <div>
                                    <Container>
                                        <Row>
                                            <Col>
                                                <Form.Label className='mt-3 mb-2'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-lbl-rut']
                                                } </Form.Label>
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {
                                                    datosCierreGestion && datosCierreGestion.datosCierreGestion[0]['RutInvolucrado'] !== undefined && datosCierreGestion.datosCierreGestion[0]['RutInvolucrado'] !== null && datosCierreGestion.datosCierreGestion[0]['RutInvolucrado'] !== '' ? formato_rut(datosCierreGestion.datosCierreGestion[0]['RutInvolucrado']) : ''
                                                } </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-lbl-nombre']
                                                } </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {
                                                    datosCierreGestion && datosCierreGestion.datosCierreGestion[0]['NombreInvolucrado'] !== undefined && datosCierreGestion.datosCierreGestion[0]['NombreInvolucrado'] !== null && datosCierreGestion.datosCierreGestion[0]['NombreInvolucrado'] !== '' ? datosCierreGestion.datosCierreGestion[0]['NombreInvolucrado'] : ''
                                                } </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-lbl-tipogestion']
                                                } </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {
                                                    datosCierreGestion && datosCierreGestion.datosCierreGestion[0]['GlosaTipoGestion'] !== undefined && datosCierreGestion.datosCierreGestion[0]['GlosaTipoGestion'] !== null && datosCierreGestion.datosCierreGestion[0]['GlosaTipoGestion'] !== '' ? datosCierreGestion.datosCierreGestion[0]['GlosaTipoGestion'] : ''
                                                } </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-lbl-ambitogest']
                                                } </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {
                                                    datosCierreGestion && datosCierreGestion.datosCierreGestion[0]['GlosaAmbitoGestion'] !== undefined && datosCierreGestion.datosCierreGestion[0]['GlosaAmbitoGestion'] !== null && datosCierreGestion.datosCierreGestion[0]['GlosaAmbitoGestion'] !== '' ? datosCierreGestion.datosCierreGestion[0]['GlosaAmbitoGestion'] : ''
                                                } </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-lbl-estado']
                                                } </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {
                                                    datosCierreGestion && datosCierreGestion.datosCierreGestion[0]['EstadoImplicado'] !== undefined && datosCierreGestion.datosCierreGestion[0]['EstadoImplicado'] !== null && datosCierreGestion.datosCierreGestion[0]['EstadoImplicado'] !== '' ? datosCierreGestion.datosCierreGestion[0]['EstadoImplicado'] : ''
                                                } </Form.Text>
                                            </Col>


                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Label className='mt-3 mb-2'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-lbl-tipovh']
                                                } </Form.Label>
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {
                                                    datosCierreGestion && datosCierreGestion.datosCierreGestion[0]['TipoVehiculo'] !== undefined && datosCierreGestion.datosCierreGestion[0]['TipoVehiculo'] !== null && datosCierreGestion.datosCierreGestion[0]['TipoVehiculo'] !== '' ? datosCierreGestion.datosCierreGestion[0]['TipoVehiculo'] : ''
                                                } </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-lbl-patente']
                                                } </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {
                                                    datosCierreGestion && datosCierreGestion.datosCierreGestion[0]['Patente'] !== undefined && datosCierreGestion.datosCierreGestion[0]['Patente'] !== null && datosCierreGestion.datosCierreGestion[0]['Patente'] !== '' ? datosCierreGestion.datosCierreGestion[0]['Patente'] : ''
                                                } </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-lbl-marca']
                                                } </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {
                                                    datosCierreGestion && datosCierreGestion.datosCierreGestion[0]['Marca'] !== undefined && datosCierreGestion.datosCierreGestion[0]['Marca'] !== null && datosCierreGestion.datosCierreGestion[0]['Marca'] !== '' ? datosCierreGestion.datosCierreGestion[0]['Marca'] : ''
                                                } </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-lbl-descripcion']
                                                } </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {
                                                    datosCierreGestion && datosCierreGestion.datosCierreGestion[0]['Descripcion'] !== undefined && datosCierreGestion.datosCierreGestion[0]['Descripcion'] !== null && datosCierreGestion.datosCierreGestion[0]['Descripcion'] !== '' ? datosCierreGestion.datosCierreGestion[0]['Descripcion'] : ''
                                                } </Form.Text>
                                            </Col>
                                            <Col></Col>
                                        </Row>
                                    </Container>
                                    <hr style={{color: '#04005D', height: '2px', marginTop: '15px'}}></hr>
                                    <Row>
                                        <Col>
                                            <Form.Text className="mt-3"
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        color: 'black'

                                                    }
                                            }>
                                                {
                                                cfg_form19.cfg_form19['cierregestion-subtitle1-recobrogest']
                                            } </Form.Text>
                                        </Col>
                                    </Row>
                                    <Container>
                                        <Row>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'style={{fontWeight: 'bold',fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-lbl-moneda']} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {montosInformados && isValidParam(montosInformados.montosInformados[0]['GlosaMoneda']) ?
                                                        montosInformados.montosInformados[0]['GlosaMoneda'] : ''
                                                    } 
                                                </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold',fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-lbl-mtoneto']} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoCosto']) ?
                                                        formatearNumero(montosInformados.montosInformados[0]['MontoCosto'], 
                                                            !(isValidParam(montosInformados.montosInformados[0]['CodMoneda']) && montosInformados.montosInformados[0]['CodMoneda'] == 30001)) 
                                                    : ''
                                                    } 
                                                </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold',fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-lbl-porcconv']} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {montosInformados && isValidParam(montosInformados.montosInformados[0]['PorConvenido']) ?
                                                        montosInformados.montosInformados[0]['PorConvenido'] : ''
                                                    } 
                                                </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold',fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-lbl-mtorecobro']}
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobro']) ?
                                                        formatearNumero(montosInformados.montosInformados[0]['MontoRecobro'], 
                                                            !(isValidParam(montosInformados.montosInformados[0]['CodMoneda']) && montosInformados.montosInformados[0]['CodMoneda'] == 30001)) 
                                                    : ''
                                                    } 
                                                </Form.Text>
                                            </Col>
                                            <Col></Col>
                                        </Row>
                                    </Container>
                                    <hr style={{color: '#04005D', height: '2px', marginTop: '15px'}}></hr>
                                    <Row>
                                        <Col>
                                            <Form.Text className="mt-3"
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        color: 'black'

                                                    }
                                                }>
                                                {cfg_form19.cfg_form19['cierregestion-subtitle2-siatuacionterm']} 
                                            </Form.Text>
                                        </Col>
                                        <Col>
                                            <Form.Check label="Con Recupero" name="group1" type='radio' id='con' value='215002'
                                                checked={isChecked}
                                                onChange={
                                                    (e) => handleChange(e)
                                                }/>
                                        </Col>
                                        <Col>
                                            <Form.Check label="Sin Recupero" name="group1" type='radio' id='sin' value='215003'
                                                onChange={
                                                    (e) => handleChange(e)
                                                }/>
                                        </Col>
                                        {/*<Col md="2">
                                            <Form.Label className='mb-2'
                                                style={
                                                    {
                                                        fontWeight: 'bold',
                                                        fontSize: '14px'
                                                    }
                                            }>
                                                {
                                                cfg_form19.cfg_form19['cierregestion-lbl-subirdocto']
                                            } </Form.Label>
                                            {' '}
                                            <br/>
                                            <OverlayTrigger overlay={
                                                <Tooltip
                                                id='tooltip-disabled'>Subir</Tooltip>
                                            }>
                                                <Button type='button' variant='subir me-md-2' size='sm'>
                                                    <ImUpload size={25}
                                                        style={
                                                            {color: 'white'}
                                                        }/>
                                                </Button>
                                            </OverlayTrigger>
                                        </Col>*/}
                                    </Row>
                                    <Container>
                                        <Row>
                                            <Col md="4">
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                    }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-cmb-registrohito']+"*"} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Select  aria-label='Default select example'
                                                    onChange={
                                                        (e) => {
                                                            formik.handleChange(e)
                                                            if (tieneRecupero == 1 && datosCierreGestion && (isValidParam(datosCierreGestion.datosCierreGestion[0]['RutInvolucrado']) && datosCierreGestion.datosCierreGestion[0]['RutInvolucrado'] <=1 || isValidParam(datosCierreGestion.datosCierreGestion[0]['NombreInvolucrado']) && datosCierreGestion.datosCierreGestion[0]['NombreInvolucrado'] == 'NO INFORMADO')) {
                                                                setShowModal(true);
                                                            } else {
                                                                setRegistrarHito(e.target.value)
                                                                if (e.target.value!=='') {                                                                
                                                                    setIsRegistraHito(true)
                                                                } else {
                                                                    setIsRegistraHito(false)
                                                                }
                                                            }                                                            
                                                        }
                                                    }
                                                    name='codHito'
                                                    value={(formik.values.codHito = registrarHito)}
                                                    error={formik.errors.codHito}
                                                >
                                                    <option value={''}>Seleccione...</option>
                                                    {
                                                    comboRegistrarHito && comboRegistrarHito.comboRegistrarHito ?. map((c) => (
                                                        <option key={
                                                                c.id
                                                            }
                                                            value={
                                                                c.id
                                                        }>
                                                            {
                                                            c.nombre
                                                        } </option>
                                                    ))
                                                } </Form.Select>
                                                {formik.errors.codHito ? (
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.codHito}
                                                    </Form.Text>
                                                    ) : (
                                                    ''
                                                )}  
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                    }>
                                                    {
                                                    cfg_form19.cfg_form19['cierregestion-input-fechaocurre']+" *"
                                                } </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Control className='mb-0' type='date'
                                                    value={
                                                        (formik.values.fechaHito = fechaOcurrencia)
                                                    }
                                                    min={
                                                        fechaMin && fechaMin
                                                      
                                                    }
                                                    max={hoy()}
                                                    name='fechaOcurrencia'
                                                    onChange={
                                                        (e) => {
                                                            formik.handleChange(e)
                                                            setFechaOcurrencia(e.target.value)
                                                        }
                                                    }
                                                    error={formik.errors.fechaOcurrencia}
                                                >                                                    
                                                </Form.Control>
                                                {formik.errors.fechaOcurrencia ? (
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.fechaOcurrencia}
                                                    </Form.Text>
                                                    ) : (
                                                    ''
                                                )}                                        
                                            </Col>
                                            <Col md="6">
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold',fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-input-comentario']} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Control as='textarea' className='mb-2'
                                                    rows={2}
                                                    onChange={
                                                        (e) => {
                                                            formik.handleChange(e)
                                                            setComentario(e.target.value)
                                                        }
                                                    }
                                                    name='minutaHito'
                                                    value={
                                                        (formik.values.minutaHito = comentario)
                                                    }
                                                    error={
                                                        formik.errors.minutaHito
                                                    }/>
                                                    {formik.errors.minutaHito ? (
                                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                                            {formik.errors.minutaHito}
                                                        </Form.Text>
                                                        ) : (
                                                        ''
                                                    )}
                                            </Col>
                                            <Col>
                                                {respuestaModalCierre && 
                                                    <Mensajes
                                                        showToast={showToast}
                                                        handleCloseToast={handleCloseToast}
                                                        delay={5000}
                                                        responseData={respuestaModalCierre?.respuestaModalCierre}
                                                    ></Mensajes>
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md='10'>
                                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    {cfg_form19.cfg_form19['cierregestion-lbl-subirdcto']}
                                                </Form.Label>
                                                <Form.Group className="position-relative mb-2 mt-1">
                                                    <Form.Control ref={fileRef} type="file" name="file"
                                                        onChange={event => { formik.setFieldValue("file", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                                                        isInvalid={!!formik.errors.file}
                                                        isValid={formik.touched.file && !formik.errors.file}
                                                    />
                                                    <Form.Text className="text-muted">Tamaño máximo del archivo: 5MB</Form.Text>
                                                    <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                                                </Form.Group>                                                
                                            </Col>
                                        </Row>
                                    </Container>
                                    <Container>
                                        <Row>
                                            <Col md="4">
                                                
                                            </Col>
                                        </Row>
                                    </Container>
                                    <hr style={{color: '#04005D', height: '0px', marginTop: '5px'}}></hr>
                            {/*<Container>
                                <Row>
                                    <Col className='d-flex align-items-end justify-content-end m-2'>
                                        <Button className='m-2 w-auto' variant='outline-info' onClick={handleCloseCierre}>
                                            {cfg_form19 && cfg_form19.cfg_form19["cierregestion-btn-cerrar"]} 
                                        </Button>
                                        <Button className='m-2' variant='actualizar' type='onSubmit'
                                            onClick={handleBuscar}
                                            name='buscar'>
                                            {cfg_form19 && cfg_form19.cfg_form19["cierregestion-btn-aplicar"]}
                                        </Button>
                                    </Col>
                                </Row>
                        </Container>*/}
                            </div>
                            ) : null
                        } 
                        </Container>
                    </Container>
                </Card>
                <Modal show={showModal} onHide={handleCloseModal} centered>
                    <Modal.Header style={{ color:'white', backgroundColor: '#4F517A' }} closeButton>
                        <Modal.Title>Datos implicado tercero.</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Debe actualizar Id/Nit y Nombre/Razón Social del implicado para cierre con recobro.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
        </>
    )
}

export default CierreGestion
